import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
declare const L: any;
import 'leaflet-easybutton';
import 'src/assets/visorgis/plugins/leaflet-measure/leaflet-measure.es.js';
import 'leaflet.zoomslider';
import 'src/assets/visorgis/plugins/leaflet-ajax/leaflet.ajax.min.js';
import 'src/assets/visorgis/plugins/leaflet.browser.print/dist/leaflet.browser.print.min.js';
/* import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.min.js'; */
import { VisorgisService } from './services/visorgis.service';
import {
  Observable,
  Subscription,
  catchError,
  combineLatest,
  forkJoin,
  map,
  take,
  tap,
  throwError,
  of,
} from 'rxjs';
import { ModalController, Platform, IonicModule } from '@ionic/angular';
import { CreateModalComponent } from './components/create-modal/create-modal.component';
import { environment } from 'src/environments/environment';
import { AuthService } from '../login/services/auth.service';
import { GetParcelasResponse, ParcelaProps } from './interfaces/parcela';
import {
  Control,
  FeatureGroup,
  LatLng,
  Layer,
  LayerGroup,
  MapOptions,
  TileLayer,
  easyButton,
  featureGroup,
  GeoJSON,
  icon,
  marker,
  DrawEvents,
} from 'leaflet';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { LeafletDirective, LeafletModule } from '@bluehalo/ngx-leaflet';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CardRightComponent } from './components/card-right/card-right.component';
import { MarkerPopupComponent } from './components/markerPopup/markerPopup.component';
import { FiltrosRapidosComponent } from './components/filtrosRapidos/filtrosRapidos.component';
import { DataService } from '../../services/data/data.service';
import { NoTranslateMaterialSymbolsDirective } from '../../shared/directives/noTranslateMaterialSymbols.directive';
import { BuscadorAutocompleteComponent } from '../../shared/components/buscador-autocomplete/buscador-autocomplete.component';
import { Router } from '@angular/router';
import { drawLocalConfig } from './interfaces/drawLocal';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { ModalFormService } from '../../shared/components/modal-form/service/modal-form.service';
import {
  LeafletDrawDirective,
  LeafletDrawModule,
} from '@bluehalo/ngx-leaflet-draw';
import { TurnoSemanal } from './interfaces/turnoSemanal.interface';
import { GpsIndicatorComponent } from '../../shared/components/mapa/components/gps-indicator/gps-indicator.component';
import { MapaService } from 'src/app/shared/components/mapa/services/mapa.service';
import { styleParcelas, styleParcelaXHidrante } from './utils/utils';
import { TeledeteccionService } from '../teledeteccion/services/teledeteccion.service';
import { addTooltipWithDelay } from './utils/addTooltipWithDelay';
import { getSectorLabel, matchesSelectedSectors } from './utils/sector.utils';
import {
  buildEnergyDevicesFeatureCollection,
  getEnergyDeviceGisLayerKey,
  getEnergyDeviceSearchTypeLabel,
} from './utils/energy-devices-geojson.utils';
import { EnergiaService } from '../energia/services/energia.service';
import {
  getEnergyDeviceTypeShortLabel,
  isEnergyDeviceType,
} from '../energia/models/energy-device.model';

enum OTROS_ELEMENTOS_RED_ENUM {
  hydraulic = 'otros elementos de red',
  energy_facilities = 'instalaciones eléctricas',
  network_elements = 'otros elementos hidráulicos',
}

const parcelaComuneroStyle = {
  fillColor: 'orange',
  fillOpacity: 0.3,
  color: 'orange',
  weight: 2.5,
  opacity: 1,
};

const parcelasTurnoStyle = {
  fillColor: 'yellow',
  fillOpacity: 0.6,
  color: 'yellow',
  weight: 2.5,
  opacity: 1,
};

const tuberiaLineStyle = { weight: 3, opacity: 1 };

function tuberiaColor(tipo?: unknown): string {
  const normalized = typeof tipo === 'string' ? tipo.trim().toUpperCase() : '';
  switch (normalized) {
    case 'PRIMARIA':
      return '#0000FF';
    case 'SECUNDARIA':
      return '#1E90FF';
    case 'TERCIARIA':
      return '#00FFFF';
    default:
      return '#0000FF';
  }
}

/**
 * Normaliza las geometrías de un GeoJSON.
 * Corrige MultiPolygons que tienen un nivel extra de anidamiento en sus coordenadas.
 */
function normalizeGeoJSONGeometries(geojson: any): any {
  if (!geojson || !geojson.features) return geojson;

  geojson.features = geojson.features.map((feature: any) => {
    if (feature.geometry?.type === 'MultiPolygon') {
      feature.geometry.coordinates = feature.geometry.coordinates.map(
        (polygon: any) => {
          // Si el primer elemento del polígono es un array de arrays de arrays,
          // tiene un nivel extra de anidamiento que debemos aplanar
          if (
            Array.isArray(polygon[0]) &&
            Array.isArray(polygon[0][0]) &&
            Array.isArray(polygon[0][0][0]) &&
            typeof polygon[0][0][0][0] === 'number'
          ) {
            // Aplanar: [[[[coords]]]] -> [[[coords]]]
            return polygon.map((ring: any) => ring[0]);
          }
          return polygon;
        }
      );
    }
    return feature;
  });

  return geojson;
}

@Component({
  selector: 'app-visorgis',
  templateUrl: './visorgis.component.html',
  styleUrls: ['./visorgis.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    IonicModule,
    FormsModule,
    LeafletModule,
    LeafletDrawModule,
    FiltrosRapidosComponent,
    CommonModule,
    NoTranslateMaterialSymbolsDirective,
    BuscadorAutocompleteComponent,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCardModule,
    GpsIndicatorComponent,
  ],
})
export class VisorgisComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly service = inject(VisorgisService);
  private readonly modalController = inject(ModalController);
  private readonly _platform = inject(Platform);
  private readonly authService = inject(AuthService);
  private readonly responsive = inject(BreakpointObserver);
  private readonly changeDetector = inject(ChangeDetectorRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly dataServices = inject(DataService);
  private readonly router = inject(Router);
  private readonly modalFormService = inject(ModalFormService);
  private readonly mapaService = inject(MapaService);
  private readonly energiaService = inject(EnergiaService);

  @ViewChild('map') map_element: ElementRef<any>;
  @ViewChild('leafletDraw') drawDirective: LeafletDrawDirective;
  currentWidth = signal<number>(0);
  options = signal<MapOptions | null>(null);
  // gis_posicion: any = environment.gis_posicion;
  gis_posicion: any;
  myMap = signal<L.Map>(null);
  lyrGoogleSatellite = signal<TileLayer>(null);
  lyrGoogleHybrid = signal<TileLayer>(null);
  lyrGoogleRoads = signal<TileLayer>(null);
  lyrGoogleTraffic = signal<TileLayer>(null);
  lyrOSM = signal<TileLayer>(null);
  lyrPNOA = signal<TileLayer.WMS>(null);
  lyrCatastro = signal<TileLayer.WMS>(null);
  lyrNecesidadesRiego = signal<TileLayer.WMS>(null);
  lyrPiezometria = signal<TileLayer.WMS>(null);
  lyrCasNitratos = signal<TileLayer.WMS>(null);
  lyrSigpacRecinto = signal<TileLayer.WMS>(null);
  lyrSigpacCultivoDeclarado = signal<TileLayer.WMS>(null);
  lyrSigpacEPaisaje = signal<TileLayer.WMS>(null);
  lyrSigpacEPaisajeLinea = signal<TileLayer.WMS>(null);
  lyrSigpacEPaisajePunto = signal<TileLayer.WMS>(null);
  layersControl: any;
  ctlGoHome: any;
  ctlLocate: Control.EasyButton;
  ctlMeasureDA: any;
  ctlZoomslider: any;
  ctlUser: any;
  ctlHome: any;
  ctlSnapshot: any;
  ctlInfo: any;
  ctlLayerSwitcher: any;
  objMarker: any;
  objCircle: any;
  objState: number;
  ctlColorPorHidrante: any;
  objState2 = false;

  ctlColorPorCultivo: any;
  lyrParcelasColor: any;
  lyrParcelasColor2: any;
  ctlRouting: Control.EasyButton;
  arParcelas: any[] = [];
  lyrHidrantes: any;
  isMeasureEnable = false;
  printControl: any;

  primaryLayerGroup = signal<LayerGroup>(new LayerGroup());

  showGpsIndicator = signal<boolean>(true);

  layers: any = {
    parcela: new FeatureGroup(),
    parcela_comunero: new FeatureGroup(),
    hidrante: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    toma: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    pozo: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    contador: [],
    balsa: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    tuberia: new FeatureGroup(),
    cabezal: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    estaciones: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
    },
    other_network_elements: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    other_energy_facilities: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    other_hydraulic: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
      without_counter: new LayerGroup(),
    },
    dispositivos_energia: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
    },
    analizadores_red: {
      active: new LayerGroup(),
      inactive: new LayerGroup(),
    },
  };
  results: any[] = [];
  isLoading = false;
  timeout: any;
  ready_subscription$ = false;

  parcelas: any;
  searchTerm: FormControl = new FormControl();
  showSearchList = false;

  lyrPozos: any;
  lyrCabezales: any;
  lyrDepositos: any;
  lyrRed: any;
  lyrImpulsion: any;
  lyrParcelas: any;
  lyrParcelasComunero: any;
  lyrTomas: any;
  lyrBalsas: any;
  lyrTuberias: LayerGroup;
  lyrEstaciones: any;
  lyrOtherHydraulic: any;
  lyrOtherEnergyFacilities: any;
  lyrOtherNetworkElements: any;
  lyrDispositivosEnergia: any;

  lyrElementosActivos: any;

  lyrParcelasPorTurnos: Layer;

  tempGeoJSON: any;
  isFirstEditMove = true;

  cToolbar: any;

  test: any;
  ctlBetterScale: any;
  lat: number | string = '0.00000';
  long: number | string = '0.00000';

  drawOptions: any;
  drawnItems: FeatureGroup = featureGroup();
  drawParcelaGeometry: any;

  makingTemp = '';
  tipo_elemento = '';
  searchParcelas: any[] = [];
  searchParcelasComunero: any[] = [];
  searchElements: any[] = [];
  searchTotal: any[] = [];
  filteredSearchTotal: any[] = [];
  observables$: Subscription[] = [];
  tempLayer: Layer;

  cultivos: any[] = [];

  showParcelasXhidrante: boolean | number = false;
  lyrParcelasXhidrante: FeatureGroup = new FeatureGroup();

  parcelasParaComparar: any[] = [];
  isIphone = false;
  on4sig = false;
  location_coords: any[];
  current_location: any;
  arDestiny: number[];
  objDestiny: any;
  arRoute: any[];
  objRoute: any;
  ctlMenuDerecho: any;
  edicionItems: FeatureGroup = new FeatureGroup();

  showBottomMessage = false;
  showBottomMessageIcon = true;
  bottomMessage = '';

  // Variable para gestión de capas
  currentLayerType: string = 'satellite';

  private _showDraw: boolean;
  private _deleteMode = false;
  private _mobileDevice = false;
  get showDraw(): boolean {
    return this._showDraw;
  }

  private get _isAdmin() {
    return this.authService.isAdminRole();
  }

  get platform() {
    return this._platform.is('ios');
  }

  get showHidrantes() {
    return this.service.hidrantes.getValue();
  }

  get showTomas() {
    return this.service.tomas.getValue();
  }

  get showPozos() {
    return this.service.pozos.getValue();
  }

  get showBalsas() {
    return this.service.balsas.getValue();
  }

  get showTuberias() {
    return this.service.tuberias.getValue();
  }

  get showCabezales() {
    return this.service.cabezales.getValue();
  }

  get showEstaciones() {
    return this.service.estaciones.getValue();
  }

  get showParcelasComunero() {
    return this.service.parcelas_comunero.getValue();
  }

  get showParcelas() {
    return this.service.parcelas.getValue();
  }

  get filtroActivos() {
    return this.service.filtroActivos.getValue();
  }

  get filtroInactivos() {
    return this.service.filtroInactivos.getValue();
  }

  get filtroSinContador() {
    return this.service.filtroSinContador.getValue();
  }

  get showOtherHydraulic() {
    return this.service.other_hydraulic.getValue();
  }

  get showOtherElectricFacilities() {
    return this.service.other_energy_facilities.getValue();
  }

  get showOtherNetworkElements() {
    return this.service.other_network_elements.getValue();
  }

  get showDispositivosEnergia() {
    return this.service.dispositivos_energia.getValue();
  }

  get showAnalizadoresRed() {
    return this.service.analizadores_red.getValue();
  }

  ngOnInit(): void {
    // Obtener la posición geográfica
    this.getGisPosition();

    // Detectar iPhone
    const userAgent = navigator.userAgent || navigator.vendor;
    this.isIphone = /iPhone/i.test(userAgent);

    this.service.current_parcelas_hidrante.subscribe(id => {
      if (id != null) {
        //console.log('ID del hidrante: ', id);
        this.getParcelaXHidrante(id);
      }
    });
    // Esto es para inicializar las variables en false en caso del que el servicio ya tenga un valor
    this.service.riegoHoy.next(false);
    this.service.riegoAyer.next(false);
    this.service.riego7dias.next(false);

    this.isLoading = false;
    this.setDrawLocal();
    this.initDrawOptions();
    this.initializeMap();

    // Inicializar el mapa con coordenadas de respaldo y luego actualizar con las reales
    this.initializeMapWithFallback();

    // this.editDrawLocal();

    this.observables$.push(
      this.responsive
        .observe('(max-width: 600px)')
        .pipe(tap((res: BreakpointState) => (this._mobileDevice = res.matches)))
        .subscribe(),

      this.service.isOn4sig().subscribe(res => (this.on4sig = res)),

      this.service.enableEdit.subscribe(res => {
        this._showDraw = res;
      }),

      this._isAdmin
        ? this.getParcelas().pipe(take(1)).subscribe()
        : forkJoin([
            this.getParcelas().pipe(take(1)),
            this.getParcelasComunero().pipe(take(1)),
          ]).subscribe(),

      this.service
        .getAllSectors()
        .pipe(
          take(1),
          tap(response => {
            this.service.availableSectors.next(response.sectors ?? []);
          }),
          catchError(() => {
            this.service.availableSectors.next([]);
            return of(null);
          })
        )
        .subscribe(),

      this.getHidrantes().subscribe(() => {
        console.log('Capa de hidrantes cargada');
        this.getNavigationState();
      }),

      this.getTomas().subscribe(() => {
        console.log('Capa de tomas cargada');
        this.getNavigationState();
      }),

      this.getPozos().subscribe(() => {
        console.log('Capa de pozos cargada');
        this.getNavigationState();
      }),

      this.getBalsas().subscribe(() => {
        console.log('Capa de balsas cargada');
        this.getNavigationState();
      }),

      this.getOtherElements().subscribe(() => {
        console.log('Capa de otros elementos cargada');
        this.getNavigationState();
      }),

      this.getTuberias().subscribe(() => {
        console.log('Capa de tuberías cargada');
      }),

      this.getCabezales().subscribe(() => {
        console.log('Capa de cabezales cargada');
        this.getNavigationState();
      }),

      this.service
        .getTipoCultivo()
        .pipe(
          tap(res => {
            this.cultivos = res.cultivos;
          })
        )
        .subscribe(),

      this.service.selectedSectorIds
        .pipe(tap(() => this.applySectorFilter()))
        .subscribe(),

      this.service.selectedTuberiaSector
        .pipe(tap(() => this.applySectorFilter()))
        .subscribe(),

      this.service.filtroActivos.pipe(tap(res => {})).subscribe(),

      // Agregar subscripciones para los filtros de elementos
      this.service.hidrantes.subscribe(() =>
        this.updateLayerVisibility('hidrante')
      ),
      this.service.pozos.subscribe(() => this.updateLayerVisibility('pozo')),
      this.service.cabezales.subscribe(() =>
        this.updateLayerVisibility('cabezal')
      ),
      this.service.tomas.subscribe(() => this.updateLayerVisibility('toma')),
      this.service.balsas.subscribe(() => this.updateLayerVisibility('balsa')),
      this.service.estaciones.subscribe(() =>
        this.updateLayerVisibility('estaciones')
      ),
      this.service.other_hydraulic.subscribe(() =>
        this.updateLayerVisibility('other_hydraulic')
      ),
      this.service.other_energy_facilities.subscribe(() =>
        this.updateLayerVisibility('other_energy_facilities')
      ),
      this.service.other_network_elements.subscribe(() =>
        this.updateLayerVisibility('other_network_elements')
      ),
      this.service.dispositivos_energia.subscribe(() => {
        this.updateLayerVisibility('dispositivos_energia');
        this.refreshFilteredSearch();
      }),
      this.service.analizadores_red.subscribe(() => {
        this.updateLayerVisibility('analizadores_red');
        this.refreshFilteredSearch();
      }),

      this.service.necesidades_riego.subscribe(() =>
        this.updateWmsOverlayVisibility('necesidades-riego')
      ),
      this.service.piezometria.subscribe(() =>
        this.updateWmsOverlayVisibility('piezometria')
      ),
      this.service.cas_nitratos.subscribe(() =>
        this.updateWmsOverlayVisibility('cas-nitratos')
      ),
      this.service.sigpac_recinto.subscribe(() =>
        this.updateWmsOverlayVisibility('sigpac-recinto')
      ),
      this.service.sigpac_cultivo_declarado.subscribe(() =>
        this.updateWmsOverlayVisibility('sigpac-cultivo-declarado')
      ),
      this.service.sigpac_e_paisaje.subscribe(() =>
        this.updateWmsOverlayVisibility('sigpac-e-paisaje')
      ),
      this.service.sigpac_e_paisaje_linea.subscribe(() =>
        this.updateWmsOverlayVisibility('sigpac-e-paisaje-linea')
      ),
      this.service.sigpac_e_paisaje_punto.subscribe(() =>
        this.updateWmsOverlayVisibility('sigpac-e-paisaje-punto')
      ),

      // Agregar subscripciones para los filtros de estado
      this.service.filtroActivos.subscribe(() => this.updateStateFilters()),
      this.service.filtroInactivos.subscribe(() => this.updateStateFilters()),
      this.service.filtroSinContador.subscribe(() => this.updateStateFilters())
    );

    if (this.dataServices.enabledMenuOpts.length == 0) {
      this.dataServices.getEnabledMenuOpts().subscribe(_ => {
        if (this.dataServices.isSensores()) {
          this.observables$.push(this.getEstaciones().subscribe());
        }
        if (this.dataServices.isEnergia()) {
          this.observables$.push(this.getDispositivosEnergia().subscribe());
        }
      });
    } else {
      if (this.dataServices.isSensores()) {
        this.observables$.push(this.getEstaciones().subscribe());
      }
      if (this.dataServices.isEnergia()) {
        this.observables$.push(this.getDispositivosEnergia().subscribe());
      }
    }

    combineLatest([
      this.service.riegoHoy,
      this.service.riegoAyer,
      this.service.riego7dias,
    ]).subscribe(([riegoHoy, riegoAyer, riego7dias]) => {
      // Si se activa cualquier filtro de riego, aplicar los filtros correspondientes
      if (riegoHoy || riegoAyer || riego7dias) {
        // Aplicar filtros de riego (esto ocultará los elementos sin datos de riego)
        this.getElementosConRiego({
          riegoHoy,
          riegoAyer,
          riego7dias,
        });
        // Forzar la detección de cambios para actualizar la interfaz
        this.changeDetector.detectChanges();
      } else {
        // Si no hay filtros de riego activos, restaurar y mostrar según los filtros de estado
        this.resetIrrigationFilters();
        this.updateStateFilters();
        // Forzar la detección de cambios para actualizar la interfaz
        this.changeDetector.detectChanges();
      }
    });
    this.service.diaFiltro.subscribe(value => {
      this.getParcelasByTurno(value, this.service.turnoFiltro.getValue());
    });
    this.service.turnoFiltro.subscribe(value => {
      this.getParcelasByTurno(this.service.diaFiltro.getValue(), value);
    });

    window.addEventListener('load', () => {
      setTimeout(() => {
        this.myMap().invalidateSize();
        this.isLoading = false;
      }, 2000);
    });
  }

  ngAfterViewInit(): void {
    this.cancelDrawSubscription();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.currentWidth.set(this.myMap().getSize().x);
  }

  onMapReady(map: L.Map) {
    this.myMap.set(map);
    setTimeout(() => {
      this.myMap().invalidateSize();
      this.currentWidth.set(this.myMap().getSize().x);
    }, 500);

    this.primaryLayerGroup()
      .addLayer(this.lyrGoogleSatellite())
      .addTo(this.myMap());

    this.ctlZoomslider = this.mapaService
      .getZoomSliderBar('topleft')
      .addTo(this.myMap());

    this.ctlLayerSwitcher = this.mapaService
      .getLayerSwitcherButton(this)
      .addTo(this.myMap());

    this.ctlGoHome = this.mapaService
      .getGoToHomeButton(this)
      .addTo(this.myMap());

    this.ctlLocate = this.mapaService
      .getMyPositionButton(this)
      .addTo(this.myMap());

    this.ctlRouting = this.mapaService.getRouteButton(this).addTo(this.myMap());

    // CORREGIR UN ERROR CON LA VERSION 1.8.0 de LEAFLET PARA ANGULAR
    L.Control.Measure.include({
      _setCaptureMarkerIcon() {
        this._captureMarker.options.autoPanOnFocus = false;
        this._captureMarker.setIcon(
          L.divIcon({
            iconSize: this._map.getSize().multiplyBy(2),
          })
        );
      },
    });

    this.ctlMeasureDA = this.mapaService
      .getMeasureButton(this)
      .addTo(this.myMap());

    this.ctlColorPorCultivo = L.easyButton(
      '<i class="material-symbols-rounded map-button" translate="no">nutrition</i>',
      () => {
        if (this.showParcelas) {
          // this.lyrParcelas = this.layers['parcela']
          this.lyrParcelas = L.geoJSON(this.parcelas, {
            style: this.objState2
              ? this.styleParcelas.bind(this)
              : this.styleChangedByTipoCultivo.bind(this),
            onEachFeature: this.processParcelas.bind(this),
          });
          this.objState2 = !this.objState2;
          this.applySectorFilter();
        }
      },
      'Ver parcelas por tipo de cultivo'
    ).addTo(this.myMap());

    this.printControl = this.mapaService
      .getPrintButton(this, {
        title: 'Guardar en PDF o imprimir region',
        documentTitle: 'Captura de Visorgis',
      })
      .addTo(this.myMap());

    this.ctlInfo = this.mapaService
      .getInfoButton(this, {
        url: 'https://cuatroplus.atlassian.net/wiki/external/ZjM0YTliOTA2N2RhNDRhZjhiOTNjMDQ1MjkyZmU3NTE',
      })
      .addTo(this.myMap());

    this.ctlBetterScale = this.mapaService
      .getBetterScaleWidget(this)
      .addTo(this.myMap());

    this.myMap().on('load', () => {
      this.myMap().invalidateSize();
    });

    this.myMap().on('draw:deletestart', () => {
      this._deleteMode = true;
    });

    this.myMap().on('draw:deletestop', () => {
      this._deleteMode = false;
    });

    this.myMap().on('measurefinish', () => {
      this.isMeasureEnable = true;
    });
    this.changeDetector.detectChanges();

    document.querySelector('#boton-print').addEventListener('click', () => {
      let modeToUse = L.BrowserPrint.Mode.Landscape();
      this.myMap()['printControl'].browserPrint.print(modeToUse);
    });

    this.syncWmsOverlays();
  }

  //se crea la función que crea el popup y el atocompletado de parcelas
  processParcelas2(json, lyr) {
    json.properties.type = 'parcela';
    const att = json.properties;

    //El evento on click dispara la peticion del contenido del popup
    lyr.bindPopup('Espere...').on('click', () => {
      if (!this._deleteMode) {
        this.observables$.push(
          this.service
            .getParcelaByRefCat(att.ref_catastral)
            .pipe(take(1))
            .subscribe((data: GetParcelasResponse) => {
              const props: ParcelaProps = data.features.find(
                (x: any) => x.properties.ref_catastral === att.ref_catastral
              ).properties;
              const popupContent = `
              <h5 class="h5-gis-popup">
                <strong>${props.name}</strong>
                ${
                  this._isAdmin
                    ? `<ion-icon class="odoo-link" id="odoo-link-${props.id}" aria-label="Ver en Odoo" title="Ver en Odoo" name="open-outline"></ion-icon><br>`
                    : '<br>'
                }
                <span class="subtitle-popup"><small>(Parcela)</small></span>
              </h5>            
              <p class="popup-left">
                ${this.getGenericParcela(props)}                
              </p>
              ${
                this._isAdmin
                  ? `<p class="popup-left"> ${this.getGenericParcelaComunero(
                      props
                    )}  </p>`
                  : ''
              }
              
              `;
              lyr.setPopupContent(popupContent).openPopup();
              if (props.hidrante_id) {
                const linked_hidrante = document.querySelector(
                  `#linked-hidrante-${props.hidrante_id}`
                );
                linked_hidrante.addEventListener(
                  'click',
                  this.findElementOnMap.bind(this, this.tempLayer)
                );
              }
              if (this._isAdmin) {
                const odoo_link = document.querySelector(
                  `#odoo-link-${props.id}`
                );
                odoo_link.addEventListener(
                  'click',
                  this.goToOdoo.bind(this, props.id, 'parcela')
                );
              }
            })
        );
      }
    });
  }

  processParcelasComunero(json, lyr) {
    json.properties.type = 'parcela_comunero';

    const att = json.properties;
    this.parcelasParaComparar.push(att.ref_catastral);

    //El evento on click dispara la peticion del contenido del popup
    lyr.bindPopup('Espere...').on('click', () => {
      if (!this._deleteMode) {
        this.service
          .getParcelaByRefCat(att.ref_catastral)
          .pipe(take(1))
          .subscribe(data => {
            const props = data.features.find(
              x => x.properties.ref_catastral === att.ref_catastral
            ).properties;
            const props_comunero = this.lyrParcelasComunero
              .getLayers()
              .find(
                x => x.feature.properties.ref_catastral === att.ref_catastral
              ).feature.properties;
            const popupContent = `
            <h5 class="h5-gis-popup">
              <strong>${props.name}</strong>
              ${
                this._isAdmin
                  ? `<ion-icon class="odoo-link" id="odoo-link-${props.id}" aria-label="Ver en Odoo" title="Ver en Odoo" name="open-outline"></ion-icon><br>`
                  : '<br>'
              }
              <span class="subtitle-popup"><small>(Parcela)</small></span>
            </h5> 
              <p class="popup-left">
                ${this.getGenericParcela(props)}<br>
                <small class="privado">Datos privados:</small><br>
                ${this.getGenericParcelaComunero(props_comunero)}
              </p>
              
          `;
            lyr.setPopupContent(popupContent).openPopup();
            if (this._isAdmin) {
              const odoo_link = document.querySelector(
                `#odoo-link-${props.id}`
              );
              odoo_link.addEventListener(
                'click',
                this.goToOdoo.bind(this, props.id, 'parcela')
              );
            }
          });
      }
    });
  }
  private desplazarPantalla(latlng: any, props: any) {
    const zoomLevel = this.myMap().getZoom();
    const displacement = 0.01 / Math.pow(2, zoomLevel - 14);
    this.myMap().setView([
      latlng.lat +
        (props.image ? displacement : 0) +
        (props.contador ? displacement : 0),
      latlng.lng,
    ]);
  }

  mostrarModal(att, tipo) {
    this.openModal(att, tipo, true);
  }

  createHidranteIcon(feature, latlng) {
    let icon;
    if (
      feature.properties.state == 'active' ||
      feature.properties.state == 'without_counter'
    ) {
      icon = 'assets/visorgis/img/hidrante.png';
    } else {
      icon = 'assets/visorgis/img/hidrante_inactivo.png';
    }
    const iconoHidrante = L.icon({
      iconUrl: icon,
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    //se crea una variable para los atributos del elemento
    const att = feature.properties;
    //primero se crea el marcador con el icono y luego el popup
    const lmarker = marker(latlng, { icon: iconoHidrante });
    addTooltipWithDelay({
      marker: lmarker,
      content: `Hidrante ${feature.properties.name}`,
    });
    return lmarker;
  }

  createTomaIcon(feature, latlng) {
    let icon;
    if (
      feature.properties.state == 'active' ||
      feature.properties.state == 'without_counter'
    ) {
      icon = 'assets/visorgis/img/toma.png';
    } else {
      icon = 'assets/visorgis/img/toma_inactivo.png';
    }
    const iconoToma = L.icon({
      iconUrl: icon,
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    //se crea una variable para los atributos del elemento
    const att = feature.properties;
    //primero se crea el marcador con el icono y luego el popup
    const lmarker = marker(latlng, { icon: iconoToma });
    addTooltipWithDelay({
      marker: lmarker,
      content: `Toma ${feature.properties.name}`,
    });
    return lmarker;
  }

  //funcion para crear el icono personalizado para la capa de pozos
  createPozoIcon(feature, latlng) {
    const iconoPozos = L.icon({
      iconUrl:
        feature.properties.state == 'active' ||
        feature.properties.state == 'without_counter'
          ? 'assets/visorgis/img/pozo.png'
          : 'assets/visorgis/img/pozo_inactivo.png',
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    //se crea una variable para los atributos del elemento
    const att = feature.properties;
    //primero se crea el marcador con el icono y luego el popup
    //se crea una variable para los atributos del elemento
    const lmarker = marker(latlng, { icon: iconoPozos });
    addTooltipWithDelay({
      marker: lmarker,
      content: `Pozo ${feature.properties.name}`,
    });
    return lmarker;
  }
  createBalsaIcon(feature, latlng) {
    const iconoBalsa = L.icon({
      iconUrl:
        feature.properties.state == 'active' ||
        feature.properties.state == 'without_counter'
          ? 'assets/visorgis/img/balsa.png'
          : 'assets/visorgis/img/balsa_inactiva.png',
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    //se crea una variable para los atributos del elemento
    const att = feature.properties;
    //primero se crea el marcador con el icono y luego el popup
    const lmarker = marker(latlng, { icon: iconoBalsa });
    addTooltipWithDelay({
      marker: lmarker,
      content: `Balsa ${feature.properties.name}`,
    });
    return lmarker;
  }

  createOtherElementIcon(feature, latlng) {
    const iconName = feature.properties.type_element;
    const iconoOtherElement = L.icon({
      iconUrl: `assets/visorgis/img/${iconName}.png`,
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    console.log('iconoOtherElement', iconoOtherElement);
    //se crea una variable para los atributos del elemento
    const att = feature.properties;
    //primero se crea el marcador con el icono y luego el popup
    const lmarker = marker(latlng, { icon: iconoOtherElement });
    addTooltipWithDelay({
      marker: lmarker,
      content: `${feature.properties.name}`,
    });
    return lmarker;
  }

  processEstacion(json, lyr: Layer) {
    this.processElement(json, lyr, 'estacion');
  }
  processToma(json, lyr: Layer) {
    this.processElement(json, lyr, 'toma');
  }
  processHidrante(json, lyr: Layer) {
    this.processElement(json, lyr, 'hidrante');
  }
  processBalsa(json, lyr: Layer) {
    this.processElement(json, lyr, 'balsa');
  }
  processPozo(json, lyr: Layer) {
    this.processElement(json, lyr, 'pozo');
  }
  processCabezal(json, lyr: Layer) {
    this.processElement(json, lyr, 'cabezal');
  }
  processParcelas(json, lyr: Layer) {
    this.processElement(json, lyr, 'parcela');
  }
  processElement(json, lyr: Layer, elementType: string) {
    json.properties.type = elementType;
    /* if (environment.name === 'CASAS') {
      json.properties.state = true;
    } */
    lyr
      .bindPopup('', {
        closeButton: false,
      })
      .on('click', () => {
        let component =
          this.viewContainerRef.createComponent(MarkerPopupComponent);
        component.instance.properties = json.properties;
        const latlng = lyr['_latlng'];
        console.log('json.properties', json.properties);
        const initComponentPopup = component.instance.initPopup();
        initComponentPopup.pipe(take(1)).subscribe(() => {
          this.changeDetector.detectChanges();
        });
        component.instance.popup = lyr
          .setPopupContent(component.location.nativeElement)
          .openPopup();
        if (latlng) this.desplazarPantalla(latlng, json.properties);
      });
  }
  createCabezalIcon(feature, latlng) {
    console.log('CABEZAL', feature.properties.current_solenoid_valve_status);

    const iconoCabezal = icon({
      iconUrl:
        feature.properties.state == 'active' ||
        feature.properties.state == 'without_counter'
          ? 'assets/visorgis/img/cabezal.png'
          : 'assets/visorgis/img/cabezal_inactivo.png',
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    //se crea una variable para los atributos del elemento
    const att = feature.properties;
    //primero se crea el marcador con el icono y luego el popup
    const lmarker = marker(latlng, { icon: iconoCabezal });
    addTooltipWithDelay({
      marker: lmarker,
      content: `Cabezal ${feature.properties.name}`,
    });
    return lmarker;
  }
  createEstacionIcon(feature, latlng) {
    const feat = { ...feature.properties };
    const iconPng = this.getEstacionIcon(feat);
    const iconoEstacion = L.icon({
      iconUrl: iconPng,
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    //se crea una variable para los atributos del elemento
    const att = feature.properties;
    //primero se crea el marcador con el icono y luego el popup
    const lmarker = marker(latlng, { icon: iconoEstacion });
    addTooltipWithDelay({
      marker: lmarker,
      content: `Estación ${feature.properties.name}`,
    });
    return lmarker;
  }

  getEstacionIcon(feat) {
    let iconName = '';

    if (feat.type.includes('Meteoro')) {
      iconName = 'est_met';
    } else if (feat.type == 'Humedad') {
      iconName = 'est_hum';
    } else if (feat.type == 'Lisímetro') {
      iconName = 'est_pl';
    } else if (feat.type == 'Nutrientes') {
      iconName = 'est_nut';
    }

    if (feat.state === 'inactive') {
      iconName += '_inactiva';
    }

    const iconPath = `assets/visorgis/img/${iconName}.png`;
    return iconPath;
  }

  processTuberia(json, lyr) {
    const att = json.properties;
    lyr.bindPopup(this.crearPopupTuberia(json, lyr), {
      className: 'popup-tuberia',
      closeButton: false,
    });
  }

  processOtherElement(json, lyr) {
    lyr.bindPopup(this.crearPopupOtherElement(json, lyr), {
      className: 'popup-tuberia',
      closeButton: false,
    });
  }

  // funcion que obtiene el event.latlng y lo convierte a formato EPSG:25830 para guardarlo en lat y lng, esta funcion se ejecutara con frecuencia de 100ms
  leafletMouseMove(e) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.lat = e.latlng.lat.toFixed(5);
      this.long = e.latlng.lng.toFixed(5);
      /* const latlng25830 = proj4('EPSG:4326', 'EPSG:25830', [
        latlng.lng,
        latlng.lat,
      ]);
      this.lat = latlng25830[1].toFixed(2);
      this.long = latlng25830[0].toFixed(2); */
    }, 50);
  }

  async openModal(att: any, tipo: string, edit: boolean = false) {
    const modal = await this.modalController.create({
      component: CreateModalComponent,
      componentProps: {
        tipo,
        geojson: edit ? att : this.tempGeoJSON,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      switch (this.tipo_elemento) {
        case 'hidrante':
          this.observables$.push(this.getHidrantes().subscribe());
          break;
        case 'toma':
          this.observables$.push(this.getTomas().subscribe());
          break;
        case 'pozo':
          this.observables$.push(this.getPozos().subscribe());
          break;
        case 'balsa':
          this.observables$.push(this.getBalsas().subscribe());
          break;
        default:
          break;
      }
    } else {
      // this.drawnItems.removeLayer(layer)
    }
  }

  styleParcelas = feature => {
    const finded = this.parcelasParaComparar.find(
      (x: any) => x === feature.properties.ref_cat
    );
    return finded
      ? {
          fillColor: 'white',
          color: 'white',
          weight: 1.5,
          opacity: 0.0,
        }
      : {
          fillColor: '#12ff01',
          color: 'white',
          weight: 1.5,
          opacity: 0.6,
        };
  };

  getParcelas() {
    return this.service.getParcelas().pipe(
      take(1),
      tap((res: any) => {
        this.parcelas = normalizeGeoJSONGeometries(res);
        this.lyrParcelas = L.geoJSON(this.parcelas, {
          style: this.styleParcelas.bind(this),
          onEachFeature: this.processParcelas.bind(this),
        });
        this.lyrParcelas.id = 'parcelas';
        this.addToSearch(this.lyrParcelas);
        this.applySectorFilter();
        console.log('✅ Capa de parcelas cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar parcelas:', err);
        // Crear una capa vacía para evitar errores en el resto del código
        this.lyrParcelas = L.geoJSON(null);
        this.lyrParcelas.id = 'parcelas';
        this.applySectorFilter();
        // Retornar un observable vacío para continuar el flujo
        return of(null);
      })
    );
  }

  getParcelasComunero() {
    return this.service.getParcelasComunero().pipe(
      take(1),
      tap((res: any) => {
        console.log('RESPUESTA ', res);
        try {
          if (typeof res === 'string') return;
          const normalizedRes = normalizeGeoJSONGeometries(res);
          this.lyrParcelasComunero = L.geoJSON(normalizedRes, {
            style: parcelaComuneroStyle,
            onEachFeature: this.processParcelas.bind(this),
          });
          this.addToSearch(this.lyrParcelasComunero);
          this.applySectorFilter();
          console.log('✅ Capa de parcelas comunero cargada exitosamente');
        } catch (error) {
          console.error('❌ Error processing parcelas comunero:', error);
          // Crear capa vacía como respaldo
          this.lyrParcelasComunero = L.geoJSON(null);
          this.applySectorFilter();
        }
      }),
      catchError(err => {
        console.error('❌ Error al cargar parcelas comunero:', err);
        // Crear una capa vacía para evitar errores
        this.lyrParcelasComunero = L.geoJSON(null);
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getHidrantes() {
    return this.service.getHidrantes().pipe(
      take(1),
      tap(res => {
        console.log('RESPUESTA ', res);

        this.lyrHidrantes = L.geoJSON(res, {
          pointToLayer: this.createHidranteIcon.bind(this),
          onEachFeature: this.processHidrante.bind(this),
        });
        // this.layers.hidrante = this.lyrHidrantes;
        this.lyrHidrantes.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.hidrante[estado]);
        });
        this.addToSearch(this.lyrHidrantes);
        this.applySectorFilter();
        console.log('✅ Capa de hidrantes cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar hidrantes:', err);
        // Crear una capa vacía para evitar errores
        this.lyrHidrantes = L.geoJSON(null);
        // Asegurarse de que las capas de estado existan
        if (!this.layers.hidrante) {
          this.layers.hidrante = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getHidranteFromToma(id) {
    const hidrantes = this.lyrHidrantes as L.GeoJSON;
    const layers: any[] = hidrantes.getLayers();
    const hidrante = layers.find(e => e.feature.properties.id == id).feature
      .properties;
    return hidrante.name;
  }

  getTomas() {
    return this.service.getTomas().pipe(
      take(1),
      tap(res => {
        this.lyrTomas = L.geoJSON(res, {
          pointToLayer: this.createTomaIcon.bind(this),
          onEachFeature: this.processToma.bind(this),
        });
        this.lyrTomas.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.toma[estado]);
        });
        this.addToSearch(this.lyrTomas);
        this.applySectorFilter();
        console.log('✅ Capa de tomas cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar tomas:', err);
        // Crear una capa vacía para evitar errores
        this.lyrTomas = L.geoJSON(null);
        // Asegurarse de que las capas de estado existan
        if (!this.layers.toma) {
          this.layers.toma = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getOtherElements() {
    return this.service.getOtherElements().pipe(
      take(1),
      tap(res => {
        // Crear capas GeoJSON para cada tipo
        this.lyrOtherHydraulic = L.geoJSON(
          {
            type: 'FeatureCollection',
            features: res.features.map(x => {
              if (x.properties.type_element === 'hydraulic') {
                x.properties.type = 'hydraulic';
              }
              return x.properties.type_element === 'hydraulic' && x;
            }),
          },
          {
            pointToLayer: this.createOtherElementIcon.bind(this),
            onEachFeature: (feature, layer) =>
              this.processOtherElement(feature, layer),
          }
        );

        this.lyrOtherEnergyFacilities = L.geoJSON(
          {
            type: 'FeatureCollection',
            features: res.features.map(x => {
              if (x.properties.type_element === 'energy_facilities') {
                x.properties.type = 'energy_facilities';
              }
              return x.properties.type_element === 'energy_facilities' && x;
            }),
          },
          {
            pointToLayer: this.createOtherElementIcon.bind(this),
            onEachFeature: (feature, layer) =>
              this.processOtherElement(feature, layer),
          }
        );

        this.lyrOtherNetworkElements = L.geoJSON(
          {
            type: 'FeatureCollection',
            features: res.features.map(x => {
              if (x.properties.type_element === 'network_elements') {
                x.properties.type = 'network_elements';
              }
              return x.properties.type_element === 'network_elements' && x;
            }),
          },
          {
            pointToLayer: this.createOtherElementIcon.bind(this),
            onEachFeature: (feature, layer) =>
              this.processOtherElement(feature, layer),
          }
        );

        // Distribuir los elementos en las capas correspondientes según su estado
        this.lyrOtherHydraulic.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.other_hydraulic[estado]);
        });

        this.lyrOtherEnergyFacilities.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.other_energy_facilities[estado]);
        });

        this.lyrOtherNetworkElements.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.other_network_elements[estado]);
        });

        // Agregar las capas a la búsqueda
        this.addToSearchOtherElements(this.lyrOtherHydraulic);
        this.addToSearchOtherElements(this.lyrOtherEnergyFacilities);
        this.addToSearchOtherElements(this.lyrOtherNetworkElements);
        this.applySectorFilter();
        console.log('✅ Capa de otros elementos cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar otros elementos:', err);
        // Crear capas vacías para evitar errores
        this.lyrOtherHydraulic = L.geoJSON(null);
        this.lyrOtherEnergyFacilities = L.geoJSON(null);
        this.lyrOtherNetworkElements = L.geoJSON(null);

        // Asegurarse de que las capas de estado existan
        if (!this.layers.other_hydraulic) {
          this.layers.other_hydraulic = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        if (!this.layers.other_energy_facilities) {
          this.layers.other_energy_facilities = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        if (!this.layers.other_network_elements) {
          this.layers.other_network_elements = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getPozos() {
    return this.service.getPozos().pipe(
      take(1),
      tap(res => {
        this.lyrPozos = L.geoJSON(res, {
          pointToLayer: this.createPozoIcon.bind(this),
          onEachFeature: this.processPozo.bind(this),
        });
        // this.layers.pozo = this.lyrPozos;
        this.lyrPozos.eachLayer((x: Layer) => {
          x.addTo(this.layers.pozo[x['feature'].properties.state]);
        });
        this.addToSearch(this.lyrPozos);
        this.applySectorFilter();
        console.log('✅ Capa de pozos cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar pozos:', err);
        // Crear una capa vacía para evitar errores
        this.lyrPozos = L.geoJSON(null);
        // Asegurarse de que las capas de estado existan
        if (!this.layers.pozo) {
          this.layers.pozo = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getBalsas() {
    return this.service.getBalsas().pipe(
      take(1),
      tap(res => {
        this.lyrBalsas = L.geoJSON(res, {
          pointToLayer: this.createBalsaIcon.bind(this),
          onEachFeature: this.processBalsa.bind(this),
        });
        // this.layers.balsa = this.lyrBalsas;
        this.lyrBalsas.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.balsa[estado]);
        });
        this.addToSearch(this.lyrBalsas);
        this.applySectorFilter();
        console.log('✅ Capa de balsas cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar balsas:', err);
        // Crear una capa vacía para evitar errores
        this.lyrBalsas = L.geoJSON(null);
        // Asegurarse de que las capas de estado existan
        if (!this.layers.balsa) {
          this.layers.balsa = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getCabezales() {
    return this.service.getCabezales().pipe(
      take(1),
      tap(res => {
        this.lyrCabezales = L.geoJSON(res, {
          pointToLayer: this.createCabezalIcon.bind(this),
          onEachFeature: this.processCabezal.bind(this),
        });
        // this.layers.cabezal = this.lyrCabezales;
        this.lyrCabezales.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.cabezal[estado]);
        });
        this.addToSearch(this.lyrCabezales);
        this.applySectorFilter();
        console.log('✅ Capa de cabezales cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar cabezales:', err);
        // Crear una capa vacía para evitar errores
        this.lyrCabezales = L.geoJSON(null);
        // Asegurarse de que las capas de estado existan
        if (!this.layers.cabezal) {
          this.layers.cabezal = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getTuberias() {
    return this.service.getTuberias().pipe(
      take(1),
      tap(res => {
        const uniqueSectorNames: string[] = [];
        const tuberiaFeatures = Array.isArray(res?.features)
          ? res.features
          : [];

        tuberiaFeatures.forEach((feature: any) => {
          const sectorLabel = getSectorLabel(feature?.properties);

          if (
            sectorLabel &&
            sectorLabel !== '-' &&
            !uniqueSectorNames.includes(sectorLabel)
          ) {
            uniqueSectorNames.push(sectorLabel);
          }
        });

        this.service.availableTuberiaSectors.next(uniqueSectorNames);

        this.lyrTuberias = L.geoJSON(res, {
          style: this.getTuberiaStyle.bind(this),
          onEachFeature: this.processTuberia.bind(this),
        });

        this.applySectorFilter();
        // this.addToSearch(this.lyrTuberias);
        console.log('✅ Capa de tuberías cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar tuberías:', err);
        // Crear una capa vacía para evitar errores
        this.service.availableTuberiaSectors.next([]);
        this.lyrTuberias = L.geoJSON(null);
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getEstaciones() {
    return this.service.getEstaciones().pipe(
      take(1),
      tap(res => {
        this.lyrEstaciones = L.geoJSON(res, {
          pointToLayer: this.createEstacionIcon.bind(this),
          onEachFeature: this.processEstacion.bind(this),
        });
        //this.layers.estacion = this.lyrEstaciones;
        this.lyrEstaciones.eachLayer((x: Layer) => {
          const estado = x['feature'].properties.state;
          x.addTo(this.layers.estaciones[estado]);
        });
        this.addToSearch(this.lyrEstaciones);
        this.applySectorFilter();
        console.log('✅ Capa de estaciones cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar estaciones:', err);
        // Crear una capa vacía para evitar errores
        this.lyrEstaciones = L.geoJSON(null);
        // Asegurarse de que las capas de estado existan
        if (!this.layers.estaciones) {
          this.layers.estaciones = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
            no_count: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  getDispositivosEnergia() {
    return this.energiaService.getDispositivos().pipe(
      take(1),
      map(devices => buildEnergyDevicesFeatureCollection(devices)),
      tap(res => {
        this.lyrDispositivosEnergia = L.geoJSON(res, {
          pointToLayer: this.createDispositivoEnergiaIcon.bind(this),
          onEachFeature: this.processDispositivoEnergia.bind(this),
        });
        this.lyrDispositivosEnergia.eachLayer((x: Layer) => {
          const deviceType = x['feature'].properties.device_type;
          const layerKey = getEnergyDeviceGisLayerKey(deviceType);
          if (!layerKey) {
            return;
          }

          const estado = x['feature'].properties.state;
          x.addTo(this.layers[layerKey][estado]);
        });
        this.addToSearch(this.lyrDispositivosEnergia);
        this.applySectorFilter();
        console.log('✅ Capa de dispositivos de energía cargada exitosamente');
      }),
      catchError(err => {
        console.error('❌ Error al cargar dispositivos de energía:', err);
        this.lyrDispositivosEnergia = L.geoJSON(null);
        if (!this.layers.dispositivos_energia) {
          this.layers.dispositivos_energia = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
          };
        }
        if (!this.layers.analizadores_red) {
          this.layers.analizadores_red = {
            active: L.featureGroup(),
            inactive: L.featureGroup(),
          };
        }
        this.applySectorFilter();
        return of(null);
      })
    );
  }

  createDispositivoEnergiaIcon(feature, latlng) {
    const isActive = feature.properties.state === 'active';
    const iconUrl = isActive
      ? 'assets/visorgis/img/dispositivo_energia.png'
      : 'assets/visorgis/img/dispositivo_energia_inactivo.png';
    const deviceType = feature.properties.device_type;
    const typeLabel = isEnergyDeviceType(deviceType)
      ? getEnergyDeviceTypeShortLabel(deviceType)
      : 'Dispositivo';
    const iconoDispositivo = L.icon({
      iconUrl,
      iconSize: [37, 37],
      popupAnchor: [-1, -10],
      iconAnchor: [18, 37],
    });
    const lmarker = marker(latlng, { icon: iconoDispositivo });
    addTooltipWithDelay({
      marker: lmarker,
      content: `${typeLabel} ${feature.properties.name}`,
    });
    return lmarker;
  }

  processDispositivoEnergia(json, lyr: Layer) {
    this.processElement(json, lyr, 'dispositivo_energia');
  }

  async initializeMap() {
    this.lyrGoogleSatellite.set(this.mapaService.getLyrGoogleSattellite());
    this.lyrGoogleHybrid.set(this.mapaService.getLyrGoogleHybrid());
    this.lyrGoogleRoads.set(this.mapaService.getLyrGoogleRoads());
    this.lyrGoogleTraffic.set(this.mapaService.getLyrGoogleTraffic());
    this.lyrOSM.set(this.mapaService.getLyrOSM());
    this.lyrPNOA.set(this.mapaService.getLyrPNOA());
    this.lyrCatastro.set(this.mapaService.getLyrCatastro());
    this.lyrNecesidadesRiego.set(this.mapaService.getLyrNecesidadesRiego());
    this.lyrPiezometria.set(this.mapaService.getLyrPiezometria());
    this.lyrCasNitratos.set(this.mapaService.getLyrCasNitratos());
    this.lyrSigpacRecinto.set(this.mapaService.getLyrSigpacRecinto());
    this.lyrSigpacCultivoDeclarado.set(
      this.mapaService.getLyrSigpacCultivoDeclarado()
    );
    this.lyrSigpacEPaisaje.set(this.mapaService.getLyrSigpacEPaisaje());
    this.lyrSigpacEPaisajeLinea.set(
      this.mapaService.getLyrSigpacEPaisajeLinea()
    );
    this.lyrSigpacEPaisajePunto.set(
      this.mapaService.getLyrSigpacEPaisajePunto()
    );

    this.layersControl = {
      baseLayers: {
        'Google Satellite': this.lyrGoogleSatellite,
        'Google Roads': this.lyrGoogleRoads,
        'Google Traffic': this.lyrGoogleTraffic,
        'Google Hybrid': this.lyrGoogleHybrid,
        OpenStreetMap: this.lyrOSM,
        PNOA: this.lyrPNOA,
        Catastro: this.lyrCatastro,
      },
    };
  }

  getTuberiaStyle(feature) {
    return {
      color: tuberiaColor(feature?.properties?.['TIPO']),
      ...tuberiaLineStyle,
    };
  }

  setInnerHTML(result) {
    if (result) {
      return (
        (result.type == 'toma' ? 'Toma #' : '') +
        result.name
          .toString()
          .replace(this.searchTerm, '<b>' + this.searchTerm + '</b>') +
        ' <small>(' +
        result.type +
        ')</small>'
      );
    } else {
      return 'No hay coincidencias';
    }
  }

  showElement(result) {
    let elemento: Layer;
    switch (result.type) {
      case 'hidrante':
        elemento = this.lyrHidrantes.getLayer(result.id);
        break;
      case 'estacion':
        elemento = this.lyrEstaciones.getLayer(result.id);
        break;
      case 'balsa':
        elemento = this.lyrBalsas.getLayer(result.id);
        break;
      case 'pozo':
        elemento = this.lyrPozos.getLayer(result.id);
        break;
      case 'toma':
        elemento = this.lyrTomas.getLayer(result.id);
        break;
      case 'cabezal':
        elemento = this.lyrCabezales.getLayer(result.id);
        break;
      case 'parcela':
        elemento = this.lyrParcelas.getLayer(result.id);
        break;
      case OTROS_ELEMENTOS_RED_ENUM.network_elements:
        elemento = this.lyrOtherNetworkElements.getLayer(result.id);
        break;
      case OTROS_ELEMENTOS_RED_ENUM.energy_facilities:
        elemento = this.lyrOtherEnergyFacilities.getLayer(result.id);
        break;
      case OTROS_ELEMENTOS_RED_ENUM.hydraulic:
        elemento = this.lyrOtherHydraulic.getLayer(result.id);
        break;
      case 'dispositivo_energia':
      case 'energia':
      case 'Contador de energía':
      case 'Analizador de red':
        elemento = this.lyrDispositivosEnergia.getLayer(result.id);
        break;
    }
    elemento.addTo(this.myMap());
    // Asegura que el mapa recalcula su tamaño y corta animaciones previas
    this.ensureMapSize();
    // pequeña espera para que el overlay cierre y libere composición en Chrome
    setTimeout(() => this.findElementOnMap(elemento), 50);
  }

  private ensureMapSize(): void {
    try {
      const map = this.myMap();
      if (!map) return;
      map.stop(); // corta animaciones previas
      map.invalidateSize(false);
      setTimeout(() => map.invalidateSize(false), 100);
      setTimeout(() => map.invalidateSize(false), 300);
    } catch {}
  }

  findElementOnMap(layer) {
    this.showSearchList = false;
    try {
      this.myMap().fitBounds(layer.getBounds(), {
        animate: false,
      });
    } catch {
      const latlng = layer.getLatLng();
      this.myMap().setView(latlng, 18, {
        animate: false,
      });
    } finally {
      // Lanza el click del layer tras un pequeño retraso para permitir el recálculo
      setTimeout(() => layer.fireEvent('click'), 300);
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.

    this.observables$.forEach(x => x.unsubscribe());
    this.observables$ = [];

    // this.mymap.remove()
  }

  showImage(base64: any, name: string) {
    const html = `
      <html>
        <head>
          <title>Hidrante: ${name}</title>
        </head>
        <body>
          <img title="Hidrante: ${name}" src="data:image/jpeg;base64, ${base64}">
        </body>
      </html>`;
    const ventana = window.open();
    ventana.document.write(html);
    ventana.document.close();
  }

  setBottomMessage(message: string, showIcon: boolean = true) {
    this.bottomMessage = message;
    this.showBottomMessageIcon = showIcon;
    this.showBottomMessage = true;
    setTimeout(() => {
      this.showBottomMessage = false;
    }, 5000);
    this.changeDetector.detectChanges();
  }

  onNoHidranteXParcela() {
    this.setBottomMessage(
      'No se encuentran parcelas asociadas al hidrante seleccionado.'
    );
  }

  getParcelaXHidrante(h_id) {
    this.myMap()?.removeLayer(this.lyrParcelasXhidrante);
    if (this.showParcelasXhidrante != h_id) {
      const aux = this.parcelas.features.filter(
        x => x.properties?.hidrante_id == h_id
      );
      if (aux.length > 0) {
        const p: any = {
          type: 'FeatureCollection',
          features: aux,
        };
        this.lyrParcelasXhidrante = L.geoJSON(p, {
          style: styleParcelaXHidrante.bind(this),
          onEachFeature: this.processParcelas.bind(this),
        });
        this.showParcelasXhidrante = h_id;
        this.myMap().addLayer(this.lyrParcelasXhidrante);
        this.myMap().fitBounds(this.lyrParcelasXhidrante.getBounds());
        this.myMap().closePopup();
      } else {
        this.showParcelasXhidrante = false;
        this.onNoHidranteXParcela();

        // this.service.presentToast('No tiene conexión a parcelas beneficiadas');
      }
    } else {
      this.showParcelasXhidrante = false;
    }
  }

  addedParcelas() {
    this.layers.parcela?.bringToBack();
  }

  onLocationFound = (e: L.LocationEvent) => {
    const iconoHidrante = L.icon({
      iconUrl: 'assets/visorgis/img/marker-icon-2x_orange.png',
      iconSize: [28, 40],
      popupAnchor: [-1, -10],
    });
    //crea un radio del tamaño de la precisión
    const radius = e.accuracy;
    //crea un marcador y lo añade al mapa
    this.objMarker = L.marker(e.latlng, { icon: iconoHidrante })
      .addTo(this.myMap())
      //con un popup que indica la precisión
      .bindPopup('Estás a ' + radius.toFixed(0) + ' metros de este punto')
      .openPopup();
    //crea un círculo del tamaño de la precisión
    this.objCircle = L.circle(e.latlng, radius, {
      color: 'red',
      fillColor: '#f03',
      fillOpacity: 0.6,
    }).addTo(this.myMap());
    //esto es para que solo funcione una vez
    e.target.removeEventListener(e.type, VisorgisComponent.arguments.callee);
  };

  //function to show an error message if the geolocation failed
  onLocationError(e) {
    alert(e.message);
  }

  async presentActionSheet() {
    this.service.presentActionSheet();
  }

  async goHome() {
    this.service.goHome();
    this.ngOnDestroy();
  }

  /** Metodo que pasado por parametro un id y un string, abre una ventana en odoo del elemento del tipo del string y el id*/
  async goToOdoo(id, tipo) {
    this.service.goToOdoo(id, tipo);
  }

  /**metodo que obtiene el id de un hidrante y devuelve una cadena en html con el nombre del hidrante desde la variable hidrantesGroup */
  getHidranteName(id) {
    if (!id) {
      return 'No asignado';
    }
    this.tempLayer = null;
    const hidrantes = this.lyrHidrantes as L.GeoJSON;
    const layers: any[] = hidrantes.getLayers();
    this.tempLayer = layers.find(e => e.feature.properties.id == id);
    return `<span class="linked-element" id="linked-hidrante-${id}">${this.tempLayer['feature'].properties.name}</span>`;
  }

  getGenericParcela(props) {
    return `
          Ref.Cat:<strong> ${props.ref_catastral}</strong><br>
          Municipio: <strong>${props.municipio}</strong><br>
          Polígono: <strong>${props.poligono_id}</strong><br>
          Parcela: <strong>${props.plot_number}</strong><br>
          Hidrante: <strong>${this.getHidranteName(
            props.hidrante_id
          )}</strong><br>`;
  }

  getGenericParcelaComunero(props: any) {
    return `
          Socio:<strong> ${props.partner}</strong><br>
          Superficie: <strong>${
            props.sup_total_m2 ? props.sup_total_m2 + ' m2' : '(No hay datos)'
          }</strong><br>
          DN Toma: <strong>${
            props.water_socket_id || '(No hay datos)'
          }</strong><br>
          <span style="font-style:italic; font-weight:bold">Ultimo riego:</span></br>
            <span style="padding-left:10px">- Fecha:<strong> ${
              props.date || '(No hay datos)'
            }</strong></span></br>
            <span style="padding-left:10px">- Consumo: <strong>${
              props.consumption || '(No hay datos)'
            }</strong></span></br>          
          Consumo campaña m3: <strong>${
            props.consumption_campaign_m3 || '(No hay datos)'
          }</strong><br>
          Consumo %: <strong>${
            props.consumption_percentage || '(No hay datos)'
          }</strong><br>`;
  }

  async createRoute(e) {
    //en primer lugar se llena la variable con las coordenadas del destino
    this.location_coords = [e.latlng.lat, e.latlng.lng];
    const ubicacion = marker(new LatLng(e.latlng.lat, e.latlng.lng))
      .bindPopup('Estas aquí')
      .openPopup();
    this.myMap()?.addLayer(ubicacion);
    this.current_location = this.location_coords.join();
    //se elimina la capa de las parcelas para que encuentre las coordenadas
    if (this.layers.parcela) {
      this.myMap()?.removeLayer(this.layers.parcela);
    }
    //ahora lo mismo con las coordenadas del punto donde hacemos click en el mapa
    this.setBottomMessage('Seleccione el destino de la ruta', false);
    /* const toast = await this.service.presentToast(
      'Seleccione el destino de la ruta',
      'warning',
      0
    ); */
    this.myMap().on('click', e => {
      /* toast.dismiss(); */
      this.arDestiny = [e.latlng.lat, e.latlng.lng];
      this.objDestiny = this.arDestiny.join();
      //y se construye la ruta que maneja el navegador para abrir el google maps
      this.arRoute = [
        'https://www.google.com/maps/dir',
        this.current_location,
        this.objDestiny,
      ];
      this.objRoute = this.arRoute.join('/');
      //se vuelve a cargar la capa de parcelas
      this.updateLayerVisibility('parcela');
      //y se abre el google maps con la rura creada
      window.open(this.objRoute);
      //esto es para que solo funcione una vez
      this.myMap().removeEventListener('click');
      this.myMap()?.removeLayer(ubicacion);
      // centrar el mapa en el destino
      this.myMap().setView(new LatLng(e.latlng.lat, e.latlng.lng), 16);
    });
  }

  // Metodo para borrar todas las mediciones de ctlMeasureDA
  clearMeasurements() {
    this.ctlMeasureDA._layer.clearLayers();
    this.isMeasureEnable = false;
  }

  getContadorData(contador) {
    return `
      <div>      
        <p class="popup-left">
          Identificador:  <strong>${contador.name}</strong><br>
          Emisor de pulsos: <strong>${
            contador.nro_emisor_pulso || 'No hay datos'
          }</strong><br>
          Estado: <strong>${
            contador.estado_valvula ? 'Abierta' : 'Cerrada'
          }</strong><br>
          Diametro: <strong>${contador.diameter || 'No hay datos'}</strong><br>
          Acumulado: <strong>${contador.current_accumulated} m³</strong><br>
          Consumo: <strong>${contador.current_consumption}</strong><br>
          Fecha de actualizacion: <strong>${
            contador.current_datetime
          }</strong><br>
        </p>
      </div>
    `;
  }

  async addToSearch(layers: LayerGroup) {
    this.searchElements = layers
      .getLayers()
      .map((x: Layer) => {
        const properties = x['feature'].properties;

        if (properties.type === 'dispositivo_energia') {
          const searchType = getEnergyDeviceSearchTypeLabel(
            properties.device_type
          );

          if (!searchType) {
            return null;
          }

          return {
            name: properties.name,
            type: searchType,
            id: x['_leaflet_id'],
          };
        }

        return {
          name: properties.name,
          type: properties.type,
          id: x['_leaflet_id'],
        };
      })
      .filter((item): item is NonNullable<typeof item> => item !== null);

    this.searchTotal = this.searchTotal.concat(this.searchElements);
    this.refreshFilteredSearch();
  }

  async addToSearchOtherElements(layers: LayerGroup) {
    this.searchElements = layers.getLayers().map((x: Layer) => ({
      name: x['feature'].properties.name,
      type: OTROS_ELEMENTOS_RED_ENUM[x['feature'].properties.type_element],
      id: x['_leaflet_id'],
    }));

    this.searchTotal = this.searchTotal.concat(this.searchElements);
  }

  crearPopupTuberia(feature, layer) {
    const sectorLabel = getSectorLabel(
      feature.properties,
      this.service.getSectorsMap()
    );
    const color = tuberiaColor(feature.properties?.['TIPO']);
    const popup = `
      <div class="popup-tuberia-area">
        <div class="popup-tuberia-title">
          <span>Tubería</span>
          <span class="material-symbols-rounded close-tuberia-button">close</span>
        </div>
        <div class="popup-tuberia-info">
          <div class="popup-tuberia-item">
            <div class="popup-tuberia-tipo" style="background-color: ${color}"></div>Tipo: ${
              feature.properties.TIPO || ': -'
            }
          </div>
          <div class="popup-tuberia-item">
            <span class="material-symbols-rounded" style="font-size: 14px">map</span> Sector ${sectorLabel}
          </div>
          <div class="popup-tuberia-item">
            <span class="material-symbols-rounded" style="font-size: 14px">hide_source</span>DN ${
              feature.properties.DN || ': -'
            }
          </div>
          <div class="popup-tuberia-item">
            <span class="material-symbols-rounded" style="font-size: 14px">valve</span>Material: ${
              feature.properties.MATERIAL || '-'
            }
          </div>
        </div>
      </div>
    `;
    let html = document.createElement('div');
    html.innerHTML = popup;
    const botonCerrar = html.getElementsByClassName('close-tuberia-button')[0];
    botonCerrar.addEventListener('click', () => {
      layer.closePopup();
    });
    return html;
  }

  crearPopupOtherElement(feature, layer) {
    const sectorLabel = getSectorLabel(
      feature.properties,
      this.service.getSectorsMap()
    );
    const popup = `
      <div class="popup-tuberia-area">
        <div class="popup-tuberia-title">
          <span>${feature.properties.name}</span>
          <span class="material-symbols-rounded close-tuberia-button">close</span>
        </div>
        <div class="popup-tuberia-info">
          <div class="popup-tuberia-item">
            Tipo: ${feature.properties.type_element_label || '-'}
          </div>
          <div class="popup-tuberia-item">
            <span class="material-symbols-rounded" style="font-size: 14px">map</span> Sector ${sectorLabel}
          </div>
          <div class="popup-tuberia-item">
            Descripción: ${feature.properties.description || '-'}
          </div>      
        </div>
      </div>
    `;
    let html = document.createElement('div');
    html.innerHTML = popup;
    const botonCerrar = html.getElementsByClassName('close-tuberia-button')[0];
    botonCerrar.addEventListener('click', () => {
      layer.closePopup();
    });
    return html;
  }

  getNavigationState() {
    const navigationState = history.state; // Acceder a history.state
    console.log(navigationState);

    if (navigationState && navigationState.elementType && navigationState.id) {
      const selectedElement = navigationState;
      console.log('Elemento seleccionado:', selectedElement);
      this.openPopupBasedOnElement(selectedElement); // Abrir el popup con el elemento seleccionado
    }
  }

  openPopupBasedOnElement(element) {
    const { elementType, id } = element;

    // Definir un mapa de capas y funciones de configuración
    const layerMapping = {
      pozo: { layer: this.lyrPozos, configure: 'setPozo' },
      balsa: { layer: this.lyrBalsas, configure: 'setBalsa' },
      toma: { layer: this.lyrTomas, configure: 'setToma' },
      cabezal: { layer: this.lyrCabezales, configure: 'setCabezal' },
      hidrante: { layer: this.lyrHidrantes, configure: 'setHidrante' },
      estacion: { layer: this.lyrEstaciones, configure: 'setEstacion' },
      dispositivo_energia: {
        layer: this.lyrDispositivosEnergia,
        configure: 'setDispositivoEnergia',
      },
    };

    const selectedLayer = layerMapping[elementType];

    if (selectedLayer) {
      this.processLayer(selectedLayer.layer, id, selectedLayer.configure);
    }
  }

  // Función auxiliar que procesa cada capa
  processLayer(layer, id, configureMethod) {
    layer.eachLayer((lyr: any) => {
      if (lyr.feature.properties.id === id) {
        const json = lyr.feature;
        let component =
          this.viewContainerRef.createComponent(MarkerPopupComponent);
        component.instance.properties = json.properties;
        const latlng = lyr['_latlng'];
        console.log('json.properties', json.properties);

        const initComponentPopup = component.instance.initPopup();
        initComponentPopup.pipe(take(1)).subscribe(() => {
          // Configurar el tipo específico del elemento
          if (typeof component.instance[configureMethod] === 'function') {
            component.instance[configureMethod]();
          }
          this.changeDetector.detectChanges();
        });

        component.instance.popup = lyr
          .setPopupContent(component.location.nativeElement)
          .openPopup();

        if (latlng) this.desplazarPantalla(latlng, json.properties);

        return;
      }
    });
  }

  // ------------------------------------------
  // #region METODOS DEL DRAW

  async onDrawCreated(e: any) {
    // this.edicionItems.addLayer(e.layer);
    this.drawnItems.addLayer((e as DrawEvents.Created).layer);
    this.drawParcelaGeometry = (
      e as DrawEvents.Created
    ).layer.toGeoJSON().geometry;
    const fixGeometry = {
      type: 'MultiPolygon',
      coordinates: [this.drawParcelaGeometry.coordinates],
    };
    console.log('fix', fixGeometry);
    this.service.createParcelaGeometry = fixGeometry;
    this.modalFormService.openDrawer.next(true);
    this.modalFormService.showingModal.next(true);

    this.service.createdParcela.subscribe(data => {
      console.log(
        'CREATED PARCELA>>>>',
        this.service.createdParcela.getValue()
      );
      if (data && this.service.createdParcela.getValue()) {
        console.log('data', data);

        this.getParcelas().subscribe(() => {
          this.service.createdParcela.next(false);
          this.drawnItems.clearLayers();
        });
      }
    });
  }

  cancelDrawSubscription() {
    this.modalFormService.showingModal.subscribe(value => {
      if (!value && !this.service.createdParcela.getValue()) {
        this.drawnItems.clearLayers();
      }
    });

    this.service.cancelDraw.subscribe(() => {
      this.service.createdParcela.next(false);
      this.drawnItems.clearLayers();
    });
  }

  setDrawLocal() {
    Object.assign(L.drawLocal, drawLocalConfig);
  }

  initDrawOptions() {
    this.drawOptions = {
      position: 'topleft',
      draw: {
        polyline: false,
        polygon: true,
        circle: false,
        marker: false,
        circlemarker: false,
        rectangle: false,
      },
    };
  }

  onDrawReady(e: any) {
    console.log('onDrawReady', e);
    const drawControlClass = document.querySelector(
      '.leaflet-draw.leaflet-control'
    );
    const routingClass = document.querySelector(
      'div.leaflet-top.leaflet-left > div:nth-child(4)'
    );
    const controlsContainer = routingClass.parentElement;
    controlsContainer.insertBefore(drawControlClass, routingClass);
  }

  // Obtener los elementos con riego segun las variables dentro de feature.properties
  // riegoHoy, riegoAyer y riego7dias para cada una de las layers (balsas,cabezalez,hidrantes,tomas,pozos)
  getElementosConRiego({
    riegoHoy = false,
    riegoAyer = false,
    riego7dias = false,
  }) {
    // Primero restauramos las capas a su estado original antes de aplicar filtros de riego
    this.resetIrrigationFilters();

    if (!riegoHoy && !riegoAyer && !riego7dias) {
      // Si todos los filtros de riego están desactivados, aplicar solo los filtros de estado
      this.updateStateFilters();
      return;
    }

    // Definimos los tipos de elementos que no contienen información de riego
    const elementsWithoutIrrigationData = [
      'estaciones',
      'dispositivos_energia',
      'analizadores_red',
      'other_hydraulic',
      'other_energy_facilities',
      'other_network_elements',
    ];

    // Ocultar explícitamente los elementos que no tienen datos de riego cuando se activa cualquier filtro
    elementsWithoutIrrigationData.forEach(elementType => {
      if (this.getLayerVisibilityState(elementType)) {
        Object.keys(this.layers[elementType]).forEach(state => {
          const layer = this.layers[elementType][state];
          // Remover todas las capas del mapa cuando hay filtros de riego activos
          if (this.myMap().hasLayer(layer)) {
            this.myMap().removeLayer(layer);
          }
        });
      }
    });

    // Aplicar los filtros de riego solo a elementos que tienen datos de riego
    const layerTypes = ['balsa', 'cabezal', 'hidrante', 'toma', 'pozo'];
    const layerGroups = {
      balsa: this.lyrBalsas,
      cabezal: this.lyrCabezales,
      hidrante: this.lyrHidrantes,
      toma: this.lyrTomas,
      pozo: this.lyrPozos,
    };

    layerTypes.forEach(type => {
      if (!this.getLayerVisibilityState(type)) return;

      const layerGroup = layerGroups[type];
      if (!layerGroup) return;

      // Crear capas temporales filtradas por riego
      const filteredLayers = this.filtrarRiego(
        layerGroup,
        riegoHoy,
        riegoAyer,
        riego7dias
      );

      // Remover todas las capas de este tipo
      Object.values(this.layers[type]).forEach((stateLayer: any) => {
        if (this.myMap().hasLayer(stateLayer)) {
          this.myMap().removeLayer(stateLayer);
        }
        stateLayer.clearLayers();
      });

      // Agregar solo las capas filtradas
      filteredLayers.forEach((layer: any) => {
        const state = layer.feature.properties.state;
        if (this.getStateFilterValue(state)) {
          this.layers[type][state].addLayer(layer);
          this.myMap().addLayer(this.layers[type][state]);
        }
      });
    });
  }

  // Método para restaurar las capas antes de aplicar los filtros de riego
  resetIrrigationFilters() {
    this.rebuildStateLayerGroups([
      'balsa',
      'cabezal',
      'hidrante',
      'toma',
      'pozo',
    ]);
  }

  // Método para actualizar la visibilidad de capas WMS superpuestas
  private getWmsOverlayConfig(): Record<
    | 'necesidades-riego'
    | 'piezometria'
    | 'cas-nitratos'
    | 'sigpac-recinto'
    | 'sigpac-cultivo-declarado'
    | 'sigpac-e-paisaje'
    | 'sigpac-e-paisaje-linea'
    | 'sigpac-e-paisaje-punto',
    { layer: () => TileLayer.WMS; visible: () => boolean }
  > {
    return {
      'necesidades-riego': {
        layer: () => this.lyrNecesidadesRiego(),
        visible: () => this.service.necesidades_riego.getValue(),
      },
      piezometria: {
        layer: () => this.lyrPiezometria(),
        visible: () => this.service.piezometria.getValue(),
      },
      'cas-nitratos': {
        layer: () => this.lyrCasNitratos(),
        visible: () => this.service.cas_nitratos.getValue(),
      },
      'sigpac-recinto': {
        layer: () => this.lyrSigpacRecinto(),
        visible: () => this.service.sigpac_recinto.getValue(),
      },
      'sigpac-cultivo-declarado': {
        layer: () => this.lyrSigpacCultivoDeclarado(),
        visible: () => this.service.sigpac_cultivo_declarado.getValue(),
      },
      'sigpac-e-paisaje': {
        layer: () => this.lyrSigpacEPaisaje(),
        visible: () => this.service.sigpac_e_paisaje.getValue(),
      },
      'sigpac-e-paisaje-linea': {
        layer: () => this.lyrSigpacEPaisajeLinea(),
        visible: () => this.service.sigpac_e_paisaje_linea.getValue(),
      },
      'sigpac-e-paisaje-punto': {
        layer: () => this.lyrSigpacEPaisajePunto(),
        visible: () => this.service.sigpac_e_paisaje_punto.getValue(),
      },
    };
  }

  updateWmsOverlayVisibility(
    overlayKey:
      | 'necesidades-riego'
      | 'piezometria'
      | 'cas-nitratos'
      | 'sigpac-recinto'
      | 'sigpac-cultivo-declarado'
      | 'sigpac-e-paisaje'
      | 'sigpac-e-paisaje-linea'
      | 'sigpac-e-paisaje-punto'
  ): void {
    const map = this.myMap();
    if (!map) {
      return;
    }

    const { layer, visible } = this.getWmsOverlayConfig()[overlayKey];
    const wmsLayer = layer();
    if (!wmsLayer) {
      return;
    }

    if (visible()) {
      if (!map.hasLayer(wmsLayer)) {
        wmsLayer.addTo(map);
      }
      wmsLayer.bringToFront();
    } else if (map.hasLayer(wmsLayer)) {
      map.removeLayer(wmsLayer);
    }
  }

  private bringWmsOverlaysToFront(): void {
    const map = this.myMap();
    if (!map) {
      return;
    }

    (
      [
        'necesidades-riego',
        'piezometria',
        'cas-nitratos',
        'sigpac-recinto',
        'sigpac-cultivo-declarado',
        'sigpac-e-paisaje',
        'sigpac-e-paisaje-linea',
        'sigpac-e-paisaje-punto',
      ] as const
    ).forEach(overlayKey => {
      const { layer, visible } = this.getWmsOverlayConfig()[overlayKey];
      const wmsLayer = layer();
      if (wmsLayer && visible() && map.hasLayer(wmsLayer)) {
        wmsLayer.bringToFront();
      }
    });
  }

  private syncWmsOverlays(): void {
    this.updateWmsOverlayVisibility('necesidades-riego');
    this.updateWmsOverlayVisibility('piezometria');
    this.updateWmsOverlayVisibility('cas-nitratos');
    this.updateWmsOverlayVisibility('sigpac-recinto');
    this.updateWmsOverlayVisibility('sigpac-cultivo-declarado');
    this.updateWmsOverlayVisibility('sigpac-e-paisaje');
    this.updateWmsOverlayVisibility('sigpac-e-paisaje-linea');
    this.updateWmsOverlayVisibility('sigpac-e-paisaje-punto');
  }

  // Método para actualizar la visibilidad de las capas según el tipo
  updateLayerVisibility(layerType: string): void {
    // Obtener el estado actual del toggle para este tipo de capa
    const isVisible = this.getLayerVisibilityState(layerType);

    // Si hay capas para este tipo, actualizar su visibilidad
    if (this.layers[layerType]) {
      // Para capas que tienen subcapas por estado (active, inactive, without_counter)
      if (
        typeof this.layers[layerType] === 'object' &&
        this.layers[layerType].active
      ) {
        Object.keys(this.layers[layerType]).forEach(state => {
          const layer = this.layers[layerType][state];
          const stateFilter = this.getStateFilterValue(state);

          if (isVisible && stateFilter) {
            // Si la capa debe estar visible y el filtro de estado está activo
            if (!this.myMap()?.hasLayer(layer)) {
              this.myMap()?.addLayer(layer);
            }
          } else {
            // Si la capa debe estar oculta o el filtro de estado está inactivo
            if (this.myMap()?.hasLayer(layer)) {
              this.myMap()?.removeLayer(layer);
            }
          }
        });
      }
      // Para capas simples sin subcapas de estado
      else {
        if (isVisible) {
          if (!this.myMap()?.hasLayer(this.layers[layerType])) {
            this.myMap()?.addLayer(this.layers[layerType]);
          }
        } else {
          if (this.myMap()?.hasLayer(this.layers[layerType])) {
            this.myMap()?.removeLayer(this.layers[layerType]);
          }
        }
      }
    }
  }

  // Método para obtener el estado de visibilidad de una capa
  getLayerVisibilityState(layerType: string): boolean {
    switch (layerType) {
      case 'hidrante':
        return this.showHidrantes;
      case 'pozo':
        return this.showPozos;
      case 'cabezal':
        return this.showCabezales;
      case 'toma':
        return this.showTomas;
      case 'balsa':
        return this.showBalsas;
      case 'estaciones':
        return this.showEstaciones;
      case 'parcela':
        return this.showParcelas;
      case 'parcela_comunero':
        return this.showParcelasComunero;
      case 'tuberia':
        return this.showTuberias;
      case 'other_hydraulic':
        return this.showOtherHydraulic;
      case 'other_energy_facilities':
        return this.showOtherElectricFacilities;
      case 'other_network_elements':
        return this.showOtherNetworkElements;
      case 'dispositivos_energia':
        return this.showDispositivosEnergia;
      case 'analizadores_red':
        return this.showAnalizadoresRed;
      default:
        return false;
    }
  }

  // Método para obtener el valor del filtro por estado
  getStateFilterValue(state: string): boolean {
    switch (state) {
      case 'active':
        return this.filtroActivos;
      case 'inactive':
        return this.filtroInactivos;
      case 'without_counter':
        return this.filtroSinContador;
      default:
        return true;
    }
  }

  // Método para actualizar los filtros de estado para todas las capas
  updateStateFilters(): void {
    // Actualizar todas las capas con estados
    const layerTypesWithStates = [
      'hidrante',
      'pozo',
      'cabezal',
      'toma',
      'balsa',
      'estaciones',
      'dispositivos_energia',
      'analizadores_red',
      'other_hydraulic',
      'other_energy_facilities',
      'other_network_elements',
    ];

    layerTypesWithStates.forEach(layerType =>
      this.updateLayerVisibility(layerType)
    );
  }
  filtrarRiego(layer, hoy, ayer, sieteDias) {
    return layer.getLayers().filter((layer: any) => {
      const props = layer.feature.properties;
      return (
        this.matchesSectorFilter(layer) &&
        ((hoy && props.irrigation_today) ||
          (ayer && props.irrigation_yesterday) ||
          (sieteDias && props.irrigation_last_7_days))
      );
    });
  }

  // Agregar este método para verificar si algún filtro de riego está activo
  anyRiegoFilterActive(): boolean {
    return (
      this.service.riegoHoy.getValue() ||
      this.service.riegoAyer.getValue() ||
      this.service.riego7dias.getValue()
    );
  }

  private getSelectedSectorIds(): number[] {
    return this.service.selectedSectorIds.getValue();
  }

  private getSectorsById(): Map<number, string> {
    return this.service.getSectorsMap();
  }

  private getCurrentIrrigationFilters() {
    return {
      riegoHoy: this.service.riegoHoy.getValue(),
      riegoAyer: this.service.riegoAyer.getValue(),
      riego7dias: this.service.riego7dias.getValue(),
    };
  }

  private getSelectedTuberiaSector(): string | null {
    const selectedSector = this.service.selectedTuberiaSector.getValue();

    return typeof selectedSector === 'string' &&
      selectedSector.trim().length > 0
      ? selectedSector.trim()
      : null;
  }

  private matchesSectorFilter(layer: Layer): boolean {
    return matchesSelectedSectors(
      layer['feature']?.properties,
      this.getSelectedSectorIds(),
      this.getSectorsById()
    );
  }

  private matchesTuberiaFilter(layer: Layer): boolean {
    const selectedSector = this.getSelectedTuberiaSector();

    if (!selectedSector) {
      return true;
    }

    return (
      getSectorLabel(layer['feature']?.properties, this.getSectorsById()) ===
      selectedSector
    );
  }

  private getSourceLayerGroup(layerType: string): LayerGroup | null {
    switch (layerType) {
      case 'parcela':
        return this.lyrParcelas;
      case 'parcela_comunero':
        return this.lyrParcelasComunero;
      case 'tuberia':
        return this.lyrTuberias;
      case 'hidrante':
        return this.lyrHidrantes;
      case 'toma':
        return this.lyrTomas;
      case 'pozo':
        return this.lyrPozos;
      case 'balsa':
        return this.lyrBalsas;
      case 'cabezal':
        return this.lyrCabezales;
      case 'estaciones':
        return this.lyrEstaciones;
      case 'other_hydraulic':
        return this.lyrOtherHydraulic;
      case 'other_energy_facilities':
        return this.lyrOtherEnergyFacilities;
      case 'other_network_elements':
        return this.lyrOtherNetworkElements;
      case 'dispositivos_energia':
      case 'analizadores_red':
        return this.lyrDispositivosEnergia;
      default:
        return null;
    }
  }

  private syncSimpleLayerGroup(
    layerType: 'parcela' | 'parcela_comunero' | 'tuberia'
  ) {
    this.layers[layerType].clearLayers();

    this.getSourceLayerGroup(layerType)?.eachLayer((layer: Layer) => {
      const matchesLayerFilters =
        layerType === 'tuberia'
          ? this.matchesTuberiaFilter(layer)
          : this.matchesSectorFilter(layer);

      if (matchesLayerFilters) {
        this.layers[layerType].addLayer(layer);
      }
    });
  }

  private rebuildStateLayerGroups(layerTypes: string[]) {
    layerTypes.forEach(layerType => {
      Object.values(this.layers[layerType]).forEach(
        (stateLayer: FeatureGroup) => {
          stateLayer.clearLayers();
        }
      );

      this.getSourceLayerGroup(layerType)?.eachLayer((layer: any) => {
        const state = layer.feature.properties.state;

        if (!this.matchesSectorFilter(layer)) {
          return;
        }

        if (!this.belongsToEnergyLayerGroup(layer, layerType)) {
          return;
        }

        this.layers[layerType][state]?.addLayer(layer);
      });
    });
  }

  private applySectorFilter(): void {
    this.syncSimpleLayerGroup('parcela');
    this.syncSimpleLayerGroup('parcela_comunero');
    this.syncSimpleLayerGroup('tuberia');

    this.rebuildStateLayerGroups([
      'hidrante',
      'pozo',
      'cabezal',
      'toma',
      'balsa',
      'estaciones',
      'dispositivos_energia',
      'analizadores_red',
      'other_hydraulic',
      'other_energy_facilities',
      'other_network_elements',
    ]);

    this.updateLayerVisibility('parcela');
    this.updateLayerVisibility('parcela_comunero');
    this.updateLayerVisibility('tuberia');

    if (this.anyRiegoFilterActive()) {
      this.getElementosConRiego(this.getCurrentIrrigationFilters());
      return;
    }

    this.updateStateFilters();
    this.updateLayerVisibility('estaciones');
    this.updateLayerVisibility('dispositivos_energia');
    this.updateLayerVisibility('analizadores_red');
  }

  private belongsToEnergyLayerGroup(layer: Layer, layerType: string): boolean {
    if (
      layerType !== 'dispositivos_energia' &&
      layerType !== 'analizadores_red'
    ) {
      return true;
    }

    const deviceType = layer['feature']?.properties?.device_type;
    return getEnergyDeviceGisLayerKey(deviceType) === layerType;
  }

  private refreshFilteredSearch(): void {
    this.filteredSearchTotal = this.searchTotal.filter(item =>
      this.isSearchItemVisible(item)
    );
  }

  private isSearchItemVisible(item: { type?: string }): boolean {
    if (item.type === 'Contador de energía') {
      return this.showDispositivosEnergia;
    }

    if (item.type === 'Analizador de red') {
      return this.showAnalizadoresRed;
    }

    return true;
  }

  getParcelasByTurno(dia, turno) {
    if (
      this.lyrParcelasPorTurnos &&
      this.myMap()?.hasLayer(this.lyrParcelasPorTurnos)
    ) {
      this.myMap()?.removeLayer(this.lyrParcelasPorTurnos);
    }
    dia = dia || 'todos';
    turno = turno || 'todos';
    if (dia === 'todos' && turno === 'todos') return [];
    let parcelas = [];
    this.lyrParcelas.eachLayer((lyr: any) => {
      const turnos: TurnoSemanal = new TurnoSemanal(
        lyr.feature.properties.turnos // MODIFICAR EN CASO DE QUE CAMBIE EN EL BACKEND
      );
      if (!turnos) return;
      if (
        (turnos[dia] && turnos[dia].includes(turno)) ||
        (turno === 'todos' && turnos[dia])
      ) {
        parcelas.push(lyr);
        return;
      }
      if (dia === 'todos') {
        turnos?.getDias().forEach(d => {
          let isAdded = false;
          if (turnos[d] && turnos[d].includes(turno)) {
            parcelas.push(lyr);
            isAdded = true;
            return;
          }
          if (isAdded) return;
        });
        return;
      }
    });
    console.log('parcelas', parcelas);
    // crear un geojson con las parcelas
    const geojson = {
      type: 'FeatureCollection',
      features: parcelas.map(x => x.feature),
    };
    this.lyrParcelasPorTurnos = L.geoJSON(geojson, {
      style: parcelasTurnoStyle,
      onEachFeature: this.processParcelas.bind(this),
    });
    this.myMap()?.addLayer(this.lyrParcelasPorTurnos);
    return parcelas;
  }

  getGisPosition(): Observable<any> {
    // Coordenadas de respaldo para España: centro aproximado con zoom que cubre todo el país
    const SPAIN_FALLBACK_COORDINATES: [number, number] = [40.4637, -3.7492]; // Madrid como centro
    const SPAIN_ZOOM_LEVEL = 6; // Zoom que permite ver toda España

    return this.service.getDataCompany().pipe(
      tap(res => {
        console.log('Datos GIS:', res);
        const dataCompany = res as CompanyData;
        this.gis_posicion =
          dataCompany.GIS_COORDINATES || SPAIN_FALLBACK_COORDINATES;
        console.log('Posicion GIS:', this.gis_posicion);
      }),
      catchError(err => {
        console.error(
          'Error al obtener la posición GIS, usando coordenadas de España:',
          err
        );
        // En caso de error, usar las coordenadas de España
        this.gis_posicion = SPAIN_FALLBACK_COORDINATES;
        console.log(
          'Usando posición de respaldo para España:',
          this.gis_posicion
        );
        // Retornar un observable exitoso con las coordenadas de respaldo
        return of({
          GIS_COORDINATES: SPAIN_FALLBACK_COORDINATES,
          isSpainFallback: true,
          zoom: SPAIN_ZOOM_LEVEL,
        });
      })
    );
  }

  styleChangedByTipoCultivo = feature => {
    const d = feature.properties.cultivo;
    const tipo = this.cultivos.find(x => x.id == d);
    const fillColor = tipo?.color || '#d8d8d8';
    const fillOpacity = tipo?.color ? 1 : 0.6;

    return {
      fillColor,
      fillOpacity,
      color: 'black',
      weight: 0.5,
      opacity: 0.7,
    };
  };

  /**
   * Inicializa el mapa con coordenadas de respaldo y luego intenta obtener las coordenadas reales
   */
  private initializeMapWithFallback(): void {
    // Coordenadas de respaldo para España
    const SPAIN_FALLBACK_COORDINATES: [number, number] = [40.4637, -3.7492];
    const DEFAULT_ZOOM = 14;
    const SPAIN_ZOOM = 7;

    // Inicializar el mapa inmediatamente con coordenadas de respaldo
    this.gis_posicion = SPAIN_FALLBACK_COORDINATES;
    this.options.set({
      layers: [this.lyrGoogleSatellite()],
      center: SPAIN_FALLBACK_COORDINATES,
      zoom: SPAIN_ZOOM, // Zoom que permite ver toda España inicialmente
      zoomControl: false,
      attributionControl: false,
      minZoom: 6,
    });

    // Intentar obtener las coordenadas reales y actualizar el mapa si es exitoso
    this.getGisPosition().subscribe(res => {
      console.log('Respuesta de posición GIS:', res);

      // Si las coordenadas son las mismas que las de respaldo, mantener el zoom de España
      const zoomToUse = res.isSpainFallback ? SPAIN_ZOOM : DEFAULT_ZOOM;

      // Actualizar las opciones del mapa con las coordenadas obtenidas
      this.options.set({
        ...this.options(),
        center: this.gis_posicion,
        zoom: zoomToUse,
      });

      // Si ya existe el mapa, actualizar su vista
      if (this.myMap) {
        this.myMap().setView(this.gis_posicion, zoomToUse);
      }
    });
  }

  /**
   * @description Cambia la capa base del mapa.
   * @param layerKey Clave de la capa a mostrar
   */
  changeMapLayer(layerKey: string) {
    const newLayer = this.mapaService.getLyrByKey(layerKey);

    // Limpiar capas actuales
    this.primaryLayerGroup().clearLayers();

    // Agregar la nueva capa base y los elementos geojson
    this.primaryLayerGroup().addLayer(newLayer);

    // Actualizar el tipo de capa actual
    this.currentLayerType = layerKey;
    this.bringWmsOverlaysToFront();
  }
}

interface CompanyData {
  GIS_COORDINATES: string; // Ajusta el tipo de dato según lo que devuelva la API
}
